

































import { Component, Vue } from 'vue-property-decorator';
import SearchBar from '@/pages/search/components/search-bar.vue';
import SearchResultCategory from '@/pages/search/components/search-result-category.vue';
import SearchResultsComponent from '@/pages/search/components/search-results-component.vue';

@Component({
	components: { SearchResultsComponent, SearchResultCategory, SearchBar },
})
export default class Search extends Vue {
	public rid: number = Math.random();

	public hasSearched: boolean = false;
	public loading: boolean = false;
	public searchValue: string = '';

	private searchResultsComponent?: SearchResultsComponent;

	public mounted() {
		const searchValue = this.$route?.query?.q?.toString() ?? '';

		const searchBar = <SearchBar>this.$refs.searchBar;

		if (!(searchValue?.trim().length > 0)) (<HTMLInputElement>searchBar.$refs.searchInput).focus();

		this.searchResultsComponent = <SearchResultsComponent>this.$refs.searchResults;
	}

	public handleInput(searchValue: string) {
		this.searchValue = searchValue;
	}

	public submitSearch(searchValue?: string): void {
		this.searchResultsComponent?.submitSearch(searchValue);
	}

	public onHasSearched(hasSearched: boolean): void {
		this.hasSearched = hasSearched;
	}

	public feelingLucky(): void {
		this.$bvModal
			.msgBoxConfirm(`No you're not`, {
				size: 'sm',
				centered: true,
				headerClass: 'border-bottom-0',
				bodyClass: 'lucky body rainbow',
				footerClass: 'lucky footer rainbow border-top-0',
				okVariant: 'light',
				okTitle: '😢',
				cancelVariant: 'success',
				cancelTitle: 'Yes I Am!',
			})
			.then((value?: boolean | null) => {
				if (value != null && !value) {
					window.open('https://www.youtube.com/watch?v=dQw4w9WgXcQ', '_blank');
				}
			});
	}
}
